import {
    ApplicationRef,
    ComponentFactoryResolver,
    ComponentRef,
    Inject,
    Injectable,
    Injector,
    Renderer2,
    RendererFactory2
} from '@angular/core';
import {Router} from '@angular/router';
import {DOCUMENT, ViewportScroller} from '@angular/common';
import {EricErrorConfig, EricErrorRoute, ericErrorTypes} from '../mapping/eric-error-map';
import {FormValidationService} from '../validation/form-validation.service';
import {CardComponent} from '../component/card/card.component';

@Injectable()
export class EricErrorNavService {
    private ericErrorRouteConfig: EricErrorConfig;
    private ericErrorNavStatus = false;
    private readonly renderer: Renderer2;
    private readonly cardInstance: ComponentRef<CardComponent> | null = null;

    private readonly router: Router;
    private readonly applicationRef: ApplicationRef;
    private readonly formValidService: FormValidationService;
    private readonly viewPortScroller: ViewportScroller;

    constructor(private readonly injector: Injector,
                @Inject(DOCUMENT) private readonly document: Document,
                private readonly resolver: ComponentFactoryResolver,
                private readonly rendererFactory: RendererFactory2) {
        this.cardInstance = this.resolver.resolveComponentFactory(CardComponent).create(injector);
        this.renderer = rendererFactory.createRenderer(null, null);

        this.router = injector.get<Router>(Router);
        this.applicationRef = injector.get<ApplicationRef>(ApplicationRef);
        this.formValidService = injector.get<FormValidationService>(FormValidationService);
        this.viewPortScroller = injector.get<ViewportScroller>(ViewportScroller);

    }

    // Remove unimportant parts of eric error message, double spaces
    static parseEricErrorMessage(errorMessage: string): string {
        return errorMessage
            .replace(/\d. /g, '')
            .replace(/ +/g, ' ');
    }

    // Due to multiple global NavigationEnd events we use a flag to toggle state
    public setEricErrorNavStatus(status: boolean): void {
        this.ericErrorNavStatus = status;
    }

    // Contains plain eric error messages after click event
    public setEricErrorMessage(errorMessage: string): void {
        const ericErrorId = EricErrorNavService.parseEricErrorMessage(errorMessage);
        this.ericErrorRouteConfig = ericErrorTypes.get(ericErrorId);
    }

    // Returns router config for route navigation
    public getEricErrorRouteConfig(): EricErrorRoute | null {
        if (this.ericErrorRouteConfig) {
            return this.ericErrorRouteConfig.route;
        }
        return null;
    }

    // Prepare Error-message as CardComponent
    public setEricErrorCard(message: string): void {
        if (this.cardInstance !== null) {
            this.cardInstance.instance.message = message;
            this.cardInstance.instance.type = 'danger';
            this.cardInstance.changeDetectorRef.detectChanges();
        }
    }

}
